import { gql } from '@apollo/client'

export default gql(`
query listMatchStatusConfig($module :String!, $project: String!){
    listConfig(
        module: $module,
        project: $project
        ){
            id,
            module,
            project,
            value
        }
}
`)
